import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import CustomCursor from './components/CustomCursor';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Jobs from './components/Jobs';
import IdGenerator from './components/IdGenerator';
import RadarMap from './components/RadarMap';
import Terminal from './components/Terminal';
import SiteProtection from './components/SiteProtection';
import Laws from './Laws.jsx';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

function PageWrapper({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
      className="flex-1 w-full flex flex-col"
    >
      {children}
    </motion.div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Hero /></PageWrapper>} />
        <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
        <Route path="/services" element={<PageWrapper><Services /></PageWrapper>} />
        <Route path="/jobs" element={<PageWrapper><Jobs /></PageWrapper>} />
        <Route path="/id-generator" element={<PageWrapper><IdGenerator /></PageWrapper>} />
        <Route path="/radar" element={<PageWrapper><RadarMap /></PageWrapper>} />
        <Route path="/laws" element={<PageWrapper><Laws /></PageWrapper>} />
        <Route path="/gallery" element={<PageWrapper><Gallery /></PageWrapper>} />
        <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <div className="bg-[#050505] min-h-screen text-white font-sans selection:bg-neon-cyan selection:text-black flex flex-col">
        <CustomCursor />
        <SiteProtection />
        <Terminal />
        <Navbar />
        <AnimatedRoutes />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
